import { AxiosError, AxiosResponse } from 'axios';
import instance, { ApiError } from 'src/api/instance';
import {
  HotelAddress,
  HotelAddressCreate,
  HotelAddressUpdate,
  HotelAddressListResponse,
  HotelAddressDeleteResponse,
} from './hotelAddress.types';

const hotelAddressPath = (companyId: string) => `/companies/${companyId}/address`;

export const getHotelAddressList = async ({
  companyId,
}: {
  companyId: string;
}): Promise<AxiosResponse<HotelAddressListResponse>> => {
  return instance.get(hotelAddressPath(companyId)).catch(e => e.response as AxiosError<ApiError> as never);
};

export const createHotelAddress = async ({ companyId, data }: { companyId: string; data: HotelAddressCreate }) => {
  return instance
    .post<HotelAddress>(hotelAddressPath(companyId), data)
    .catch(e => e.response as AxiosError<ApiError> as never);
};

export const updateHotelAddress = async ({ companyId, data }: { companyId: string; data: HotelAddressUpdate }) => {
  return instance
    .put<HotelAddress>(hotelAddressPath(companyId), data)
    .catch(e => e.response as AxiosError<ApiError> as never);
};

export const deleteHotelAddress = async ({
  companyId,
  addressId,
}: {
  companyId: string;
  addressId: string;
}): Promise<AxiosResponse<HotelAddressDeleteResponse>> => {
  return instance
    .delete(hotelAddressPath(companyId), { data: { address_id: addressId } })
    .catch(e => e.response as AxiosError<ApiError> as never);
};
